// extracted by mini-css-extract-plugin
module.exports = {"home4":"home4_home4__41EHJ"};